import React from "react";
import { Button } from "app/components/ui/button";

interface Props {
  isVisible: boolean;
  onClose: () => void;
}

export const MaintenanceBanner = ({ isVisible, onClose }: Props) => {
  return (
    <div
      id="maintenance-banner"
      className={`sticky top-0 z-[60] w-full bg-[#FFE1D259] overflow-hidden transition-all duration-300 ease-in-out ${
        isVisible ? "h-10 sm:h-11 lg:h-12 opacity-100" : "h-0 opacity-0"
      }`}
    >
      {/* bg-[#FFABAB] */}
      <div className="relative flex items-center justify-center h-full w-full max-w-[85rem] mx-auto px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
        <div className="flex flex-col items-center justify-center text-center pb-px sm:pb-0.5 lg:pb-1">
          <p className="text-[#333333] text-[0.72rem] sm:text-xs md:text-[0.825rem] lg:text-sm font-bold leading-[1.2]">
            {/* Checkout is temporarily unavailable while we perform upgrades. */}
            We're currently upgrading our system, checkout will be back soon.
          </p>
          {/* <span className="inline-block italic text-[#333333] text-[0.65625rem] sm:text-[0.66875rem] md:text-[0.6875rem] lg:text-[0.7rem] font-normal leading-none">
            We'll be back shortly.
          </span> */}
        </div>
        <Button
          type="button"
          variant="ghost"
          className="absolute z-10 right-3 sm:right-4 md:right-5 lg:right-6 hover:bg-transparent hover:brightness-75 size-3 sm:size-[0.8125rem] md:size-3.5 lg:size-[0.9375rem] p-0 rounded-none"
          onClick={() => onClose()}
          aria-label="Close banner"
        >
          <img
            src="/assets/cross-square.svg"
            alt="close"
            className="size-full"
          />
        </Button>
      </div>
    </div>
  );
};
